import {routeComponentRecoveryPath, reserveRouteComponentRecovery} from '~/utils/route-component-recovery.mjs';

export default defineNuxtPlugin(nuxt => {
 nuxt.$router.onError((error, to) => {
  const path = routeComponentRecoveryPath(error, to);
  if (!path) return;
  try {
   if (!reserveRouteComponentRecovery(window.sessionStorage, path)) return;
  } catch { return; }
  nuxt.runWithContext(() => reloadNuxtApp({path, persistState: true, ttl: 60_000}));
 });
});
